var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.83 51H4.17C2.42 51 1 49.58 1 47.83V29.17C1 27.42 2.42 26 4.17 26H22.82C24.57 26 25.99 27.42 25.99 29.17V47.82C26 49.58 24.58 51 22.83 51Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.83 51H4.17C2.42 51 1 49.58 1 47.83V29.17C1 27.42 2.42 26 4.17 26H22.82C24.57 26 25.99 27.42 25.99 29.17V47.82C26 49.58 24.58 51 22.83 51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7299 26H8.37988V36.35H18.7299V26Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7299 26H8.37988V36.35H18.7299V26Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.33 26H16.67C14.92 26 13.5 24.58 13.5 22.83V4.17C13.5 2.42 14.92 1 16.67 1H35.32C37.07 1 38.49 2.42 38.49 4.17V22.82C38.5 24.58 37.08 26 35.33 26Z",
    fill: "#FFCF00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.83 51H29.17C27.42 51 26 49.58 26 47.83V29.17C26 27.42 27.42 26 29.17 26H47.82C49.57 26 50.99 27.42 50.99 29.17V47.82C51 49.58 49.58 51 47.83 51Z",
    fill: "#FFCF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2299 1H20.8799V11.35H31.2299V1Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7299 26H33.3799V36.35H43.7299V26Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.33 26H16.67C14.92 26 13.5 24.58 13.5 22.83V4.17C13.5 2.42 14.92 1 16.67 1H35.32C37.07 1 38.49 2.42 38.49 4.17V22.82C38.5 24.58 37.08 26 35.33 26Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2299 1H20.8799V11.35H31.2299V1Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.83 51H29.17C27.42 51 26 49.58 26 47.83V29.17C26 27.42 27.42 26 29.17 26H47.82C49.57 26 50.99 27.42 50.99 29.17V47.82C51 49.58 49.58 51 47.83 51Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7299 26H33.3799V36.35H43.7299V26Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.a0ea8e1943b2232fe6a029c0a5fe312d.svg";
export { ForwardRef as ReactComponent };